import { z } from "zod";
import { idSchema, paginatedResponseSchema, sortDirectionSchema } from "./shared";

export const savedViewSchema = z.object({
  id: idSchema,
  workspaceId: idSchema,
  name: z.string().min(1),
  filters: z.record(z.string(), z.unknown()),
  sort: z.object({
    field: z.string().min(1),
    direction: sortDirectionSchema,
  }),
});

export const createSavedViewRequestSchema = savedViewSchema.omit({
  id: true,
  workspaceId: true,
});

export const savedViewsResponseSchema = paginatedResponseSchema(savedViewSchema);
